enum BillStatus {
  Pending = "Pending",
  AwaitingPaymentConfirmation = "AwaitingPaymentConfirmation",
  PaymentFailed = "PaymentFailed",
  Paid = "Paid",
  Discounted = "Discounted",
  Canceled = "Canceled",
  Refunded = "Refunded"
}
export default BillStatus